(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["absina-newsletter-widget"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('absina-newsletter-widget')) {
    customElements.define('absina-newsletter-widget', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const panel = this.querySelector('[role="region"]');
        const trigger = this.querySelector('[data-newsletter-trigger]');
        if (!panel || !trigger) return;
        const viewport = window.visualViewport;
        const resize = () => {
          const height = viewport ? viewport.height : window.innerHeight;
          const offset = viewport ? Math.max(0, window.innerHeight - viewport.height - viewport.offsetTop) : 0;
          this.style.setProperty('--absina-newsletter-viewport-height', `${height}px`);
          this.style.setProperty('--absina-newsletter-keyboard-offset', `${offset}px`);
        };
        const close = (restoreFocus = true) => {
          panel.hidden = true;
          trigger.setAttribute('aria-expanded', 'false');
          if (restoreFocus) trigger.focus({ preventScroll: true });
        };
        const open = (focusInput = true) => {
          panel.hidden = false;
          trigger.setAttribute('aria-expanded', 'true');
          resize();
          if (focusInput && window.matchMedia('(min-width: 750px)').matches) panel.querySelector('input[type="email"]')?.focus({ preventScroll: true });
        };
        trigger.addEventListener('click', () => panel.hidden ? open() : close(), options);
        this.querySelector('[data-newsletter-close]').addEventListener('click', () => close(), options);
        document.addEventListener('keydown', event => {
          if (event.key === 'Escape' && !panel.hidden) close(this.contains(document.activeElement));
        }, options);
        document.addEventListener('dialog:after-show', () => close(false), options);
        document.addEventListener('shopify:section:select', event => { if (event.target.contains(this)) open(false); }, options);
        document.addEventListener('shopify:section:deselect', event => { if (event.target.contains(this)) close(false); }, options);
        viewport?.addEventListener('resize', resize, options);
        viewport?.addEventListener('scroll', resize, options);
        window.addEventListener('resize', resize, options);
        resize();
        const form = panel.querySelector('form');
        if (form && window.location.hash === `#${form.id}` && form.querySelector('[data-absina-newsletter-result]:not([hidden]), [data-newsletter-error]:not([hidden])')) open(false);
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
if (!customElements.get('absina-cart-page')) {
  customElements.define('absina-cart-page', class extends HTMLElement {
    connectedCallback() {
      this.events?.abort();
      this.events = new AbortController();
      const signal = this.events.signal;
      this.addEventListener('change', event => {
        const input = event.target.closest('input[data-line-key]');
        if (!input) return;
        event.stopPropagation();
        if (this.busy || this.needsRefresh) return;
        if (input.value.trim() === '' || !Number.isSafeInteger(Number(input.value)) || !input.checkValidity()) {
          input.reportValidity();
          input.value = input.defaultValue;
          return;
        }
        this.changeQuantity(input.dataset.lineKey, Number(input.value));
      }, { capture: true, signal });
      this.addEventListener('click', event => {
        const refresh = event.target.closest('[data-cart-refresh]');
        if (refresh) {
          event.preventDefault();
          this.refresh();
          return;
        }
        const link = event.target.closest('line-item-quantity a[href]');
        if (!link) return;
        const url = new URL(link.href);
        if (!url.pathname.endsWith('/cart/change')) return;
        event.preventDefault();
        event.stopPropagation();
        if (!this.busy && !this.needsRefresh) this.changeQuantity(url.searchParams.get('id'), 0);
      }, { capture: true, signal });
      this.addEventListener('submit', event => {
        if (this.busy || this.needsRefresh) event.preventDefault();
      }, { capture: true, signal });
      document.addEventListener('cart:prepare-bundled-sections', event => {
        if (!event.detail.sections.includes(this.dataset.sectionId)) event.detail.sections.push(this.dataset.sectionId);
      }, { signal });
      document.addEventListener('cart:change', event => {
        if (event.detail.source === this) return;
        this.renderCart(event.detail.cart).catch(() => this.refresh());
      }, { signal });
      document.addEventListener('cart:refresh', () => this.refresh(), { signal });
      window.addEventListener('pageshow', event => {
        if (event.persisted) this.refresh();
      }, { signal });
      this.observeCheckout();
    }

    disconnectedCallback() {
      this.events?.abort();
      this.checkoutObserver?.disconnect();
    }

    sectionIds() {
      const sections = [this.dataset.sectionId];
      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
        bubbles: true, detail: { sections }
      }));
      return [...new Set(sections)].slice(0, 5);
    }

    observeCheckout() {
      this.checkoutObserver?.disconnect();
      const checkout = this.querySelector('.cart-form [name="checkout"]');
      const bar = this.querySelector('.absina-cart-mobile-checkout');
      if (!checkout || !bar || !window.IntersectionObserver) return;
      this.checkoutObserver = new IntersectionObserver(entries => {
        bar.hidden = entries[0].isIntersecting;
      });
      this.checkoutObserver.observe(checkout);
    }

    setBusy(busy) {
      this.busy = busy;
      this.setAttribute('aria-busy', String(busy));
      if (busy) {
        this.disabledControls = [...this.querySelectorAll('line-item-quantity input, line-item-quantity button, [name="checkout"], [data-cart-refresh]')]
          .map(element => ({ element, disabled: element.disabled }));
        this.disabledControls.forEach(({ element }) => { element.disabled = true; });
        this.querySelectorAll('line-item-quantity a').forEach(link => link.setAttribute('aria-disabled', 'true'));
        this.querySelector('[data-cart-status]').textContent = this.dataset.updating;
      } else {
        this.disabledControls?.forEach(({ element, disabled }) => { element.disabled = disabled; });
        this.querySelectorAll('line-item-quantity a').forEach(link => link.removeAttribute('aria-disabled'));
        if (this.needsRefresh) this.querySelectorAll('[name="checkout"]').forEach(button => { button.disabled = true; });
      }
    }

    async fetchSections(ids) {
      const url = new URL(`${Shopify.routes.root}cart`, location.origin);
      url.searchParams.set('sections', ids.join(','));
      const response = await fetch(url, { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error(this.dataset.error);
      return response.json();
    }

    async currentCart() {
      const response = await fetch(`${Shopify.routes.root}cart.js`, { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error(this.dataset.error);
      const cart = await response.json();
      cart.sections = await this.fetchSections(this.sectionIds());
      return cart;
    }

    async renderCart(cart, focus) {
      const ids = this.sectionIds();
      if (ids.some(id => !cart.sections?.[id])) {
        cart.sections = { ...cart.sections, ...await this.fetchSections(ids) };
      }
      const html = cart.sections[this.dataset.sectionId];
      if (!html) throw new Error(this.dataset.error);
      const next = new DOMParser().parseFromString(html, 'text/html').querySelector('absina-cart-page');
      if (!next) throw new Error(this.dataset.error);
      const note = this.querySelector('[name="note"]');
      const noteValue = note?.value;
      const noteOpen = this.querySelector('.absina-cart-note')?.open;
      const scrollX = window.scrollX;
      const scrollY = window.scrollY;
      this.innerHTML = next.innerHTML;
      const newNote = this.querySelector('[name="note"]');
      if (newNote && noteValue !== undefined) newNote.value = noteValue;
      const noteDetails = this.querySelector('.absina-cart-note');
      if (noteDetails && noteOpen !== undefined) noteDetails.open = noteOpen;
      this.needsRefresh = false;
      this.observeCheckout();
      if (focus) {
        const inputs = [...this.querySelectorAll('input[data-line-key]')];
        const input = inputs.find(element => element.dataset.lineKey === focus.key && element.getClientRects().length);
        const selector = input?.closest('quantity-selector');
        let target = input;
        if (focus.buttonIndex !== undefined) {
          target = selector?.querySelectorAll('button')[focus.buttonIndex];
          if (target?.disabled) target = selector?.querySelector('button:not(:disabled)');
        }
        target ||= this.querySelector('.cart-form [name="checkout"]') || this.querySelector('.empty-state a');
        target?.focus({ preventScroll: true });
      }
      window.scrollTo({ left: scrollX, top: scrollY, behavior: 'instant' });
      this.querySelector('[data-cart-status]').textContent = this.dataset.updated;
    }

    publishCart(cart) {
      document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
        bubbles: true, detail: { baseEvent: 'line-item:change', source: this, cart }
      }));
    }

    showError(message) {
      const error = this.querySelector('[data-cart-error]');
      error.querySelector('[data-cart-error-message]').textContent = message || this.dataset.error;
      error.hidden = false;
    }

    async refresh() {
      if (this.busy) return;
      this.setBusy(true);
      try {
        const cart = await this.currentCart();
        await this.renderCart(cart);
        this.publishCart(cart);
      } catch (_) {
        this.needsRefresh = true;
        this.showError(this.dataset.error);
      } finally {
        this.setBusy(false);
      }
    }

    async changeQuantity(key, quantity) {
      if (!key || !Number.isSafeInteger(quantity) || quantity < 0) return;
      const active = document.activeElement;
      const buttons = active?.closest('quantity-selector')?.querySelectorAll('button');
      const buttonIndex = buttons ? [...buttons].indexOf(active) : -1;
      const focus = { key, buttonIndex: buttonIndex >= 0 ? buttonIndex : undefined };
      this.setBusy(true);
      this.querySelector('[data-cart-error]').hidden = true;
      try {
        const response = await fetch(`${Shopify.routes.root}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity, sections: this.sectionIds(), sections_url: `${Shopify.routes.root}cart` })
        });
        const cart = await response.json();
        if (!response.ok || !Array.isArray(cart.items)) {
          throw new Error(typeof cart.description === 'string' ? cart.description : this.dataset.error);
        }
        await this.renderCart(cart, focus);
        this.publishCart(cart);
      } catch (error) {
        try {
          const cart = await this.currentCart();
          await this.renderCart(cart, focus);
          this.publishCart(cart);
        } catch (_) {
          this.needsRefresh = true;
          this.querySelectorAll('input[data-line-key]').forEach(input => { input.value = input.defaultValue; });
        }
        this.showError(error.message);
      } finally {
        this.setBusy(false);
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-jannis-product-card-cleanup"]) return;
  try {
    
if (!customElements.get('jannis-product-card-cleanup')) {
  customElements.define('jannis-product-card-cleanup', class extends HTMLElement {
    connectedCallback() {
      this.scheduleCleanup = this.scheduleCleanup.bind(this);
      this.clean = this.clean.bind(this);
      this.scheduleCleanup();
      this.observer = new MutationObserver(this.scheduleCleanup);
      this.observer.observe(document.documentElement, { childList: true, subtree: true });
    }

    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
      }
    }

    scheduleCleanup() {
      if (this.cleanupQueued) {
        return;
      }

      this.cleanupQueued = true;
      requestAnimationFrame(() => {
        this.cleanupQueued = false;
        this.clean();
      });
    }

    clean() {
      this.targetSections().forEach((section) => {
        section.querySelectorAll('product-card, .product-card').forEach((card) => this.cleanCardRatings(card));
      });
    }

    targetSections() {
      return document.querySelectorAll('#shopify-section-featured-collection, #shopify-section-featured_collection_WfUPjR, [id$="__featured-collection"], [id$="__featured_collection_WfUPjR"]');
    }

    cleanCardRatings(card) {
      let hasVisibleRating = false;

      this.ratingElements(card).forEach((rating) => {
        if (!this.looksLikeRating(rating)) {
          return;
        }

        if (hasVisibleRating) {
          rating.hidden = true;
          return;
        }

        hasVisibleRating = true;
        this.hideReviewCount(rating);
      });
    }

    ratingElements(card) {
      return [...card.querySelectorAll('.product-card__rating, .rating, .rating-badge, .spr-badge, .jdgm-prev-badge, .loox-rating, [class*="areviews"], [class*="rating"], [class*="review"]')]
        .filter((element) => element instanceof HTMLElement && !element.closest('script, style') && element.textContent.trim());
    }

    looksLikeRating(element) {
      const text = element.textContent.replace(/\s+/g, ' ').trim().toLowerCase();
      return text.includes('\u2605') || text.includes('\u2606') || text.includes('bewertung') || text.includes('review') || /\(\s*\d[\d.,]*\s*\)/.test(text);
    }

    hideReviewCount(rating) {
      rating.childNodes.forEach((node) => {
        if (node.nodeType === Node.TEXT_NODE) {
          node.textContent = node.textContent.replace(/\s*\(\s*\d[\d.,]*\s*\)\s*/g, ' ');
        }
      });

      rating.querySelectorAll('*').forEach((element) => {
        if (/^\(\s*\d[\d.,]*\s*\)$/.test(element.textContent.trim())) {
          element.hidden = true;
        }
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
